import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ensures every route change scrolls back to the top of the page.
 * Mount once inside the Router so it watches all navigations.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Try to scroll to the hash target. Retry briefly because target
      // may not be mounted on the first render after route change.
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        if (attempts++ < 20) setTimeout(tryScroll, 60);
      };
      tryScroll();
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
